import { Schema } from 'further-types/lp/account';
import { isMongoId } from '../../helpers';
import { z } from 'zod';

export const ListAll = z.object({
  searchQuery: z.string().optional().nullable(),
});

const accountBaseFields = z.object({
  section: z.nativeEnum(Schema.AccountSection),
  accountName: z.string().min(1, 'Please enter account name.'),
  accountCode: z.string().min(1, 'Please enter account code.'),
  balanceSheetSection: z.nativeEnum(Schema.BalanceSheetSection).optional(),
  payable: z.boolean().optional(),
  receivable: z.boolean().optional(),
  isPrepaidExpenses: z.boolean().optional(),
  isDeferredIncome: z.boolean().optional(),
  isBankTransferReceivable: z.boolean().optional(),
});

type AccountBaseInferred = z.infer<typeof accountBaseFields>;

const balanceSheetSectionRefinementIssue = {
  message:
    'Balance sheet section is required for Assets and Payables accounts.',
  path: ['balanceSheetSection'],
};

function meetsBalanceSheetSectionRules(
  data: AccountBaseInferred & { id?: string },
): boolean {
  if (
    data.section === Schema.AccountSection.Assets ||
    data.section === Schema.AccountSection.Payables
  ) {
    return !!data.balanceSheetSection;
  }
  return true;
}

export const CreateAccount = accountBaseFields.refine(
  meetsBalanceSheetSectionRules,
  balanceSheetSectionRefinementIssue,
);

export const UpdateAccount = accountBaseFields
  .extend({ id: z.string().refine(isMongoId()) })
  .refine(meetsBalanceSheetSectionRules, balanceSheetSectionRefinementIssue);

export const DeleteAccount = z.object({
  id: z.string().refine(isMongoId()),
});
